// Which BadgeSquare a mission status shows. Shared so a status reads the same
// wherever a mission is listed — mission cards, and the slide-over lists.
export const MISSION_STATUS_BADGE_TYPE = {
  suspended: 22,
  canceled: 23,
  interrupted: 24,
  deleted: 25,
};
